import {FetchBaseQueryError, FetchBaseQueryMeta} from "@reduxjs/toolkit/query";

import {getOriginalStatus} from "../../store/utils/get_original_status";
import {getSilentErrorResponse, ISilentErrorReport} from "../../store/utils/get_silent_error_response";
import {IReservationError, ReservationErrorKind, ReservationPhase} from "../types/IReservationError";
import {getApiErrorCode} from "./api_error_text";
import {normalizeReservationError} from "./normalize_reservation_error";

type ReservationErrorReporter = (error: IReservationError, originalStatus: number | undefined) => ISilentErrorReport;

const reportAuthError: ReservationErrorReporter = ({kind, phase, raw}, originalStatus) => ({
    error: {name: "ReservationAuthError", message: kind, groupingHash: `reservation_${phase}_${kind}`},
    context: `reservation ${phase}: ${kind}`,
    metadata: {raw, originalStatus}
});

// The kinds without a reporter are answers the flow expects
const RESERVATION_ERROR_REPORTERS: Partial<Record<ReservationErrorKind, ReservationErrorReporter>> = {
    // expected statuses, which would disappear from Bugsnag without a report
    unauthenticated: reportAuthError,
    not_verified: reportAuthError,
    forbidden: reportAuthError,
    csrf: reportAuthError,
    server: ({phase, raw}, originalStatus) => ({
        error: {name: "ReservationUpstreamError", message: String(originalStatus ?? raw.status), groupingHash: `reservation_${phase}_upstream`},
        context: `reservation ${phase} upstream failure`,
        metadata: {raw, originalStatus}
    }),
    // reported per code, so that a code the frontend does not map yet, a 409 without a code or a missing phone shows up
    rejected: ({phase, raw}) => {
        const apiErrorCode = getApiErrorCode(raw.data) ?? "no_code";

        return {
            error: {name: "ReservationRejectedError", message: apiErrorCode, groupingHash: `reservation_${phase}_rejected_${apiErrorCode}`},
            context: `reservation ${phase} rejected: ${apiErrorCode}`,
            metadata: {raw}
        };
    },
    // a status the flow does not expect, e.g. missing routes after a deployment or a success without its data
    unknown: ({phase, raw}) => ({
        error: {name: "ReservationUnexpectedError", message: String(raw.status), groupingHash: `reservation_${phase}_unexpected`},
        context: `reservation ${phase} unexpected response`,
        metadata: {raw}
    })
};

/**
 * `transformErrorResponse` of the initiate and confirm mutations: `data` becomes `IReservationError`.
 * Every status is silent - without it the RTK middleware turns a 5xx into the full-page error view, which unmounts the reservation modal.
 */
export const transformReservationError = (response: FetchBaseQueryError, phase: ReservationPhase, meta?: FetchBaseQueryMeta) => {
    const error = normalizeReservationError(response, phase, meta);
    const report = RESERVATION_ERROR_REPORTERS[error.kind]?.(error, getOriginalStatus(response)) ?? null;

    // the flag is set on the response object itself, so it has to be spread - a fresh object would lose it
    return {...getSilentErrorResponse(response, report), data: error};
};

/**
 * `transformErrorResponse` of the availability query: silent for the page, which only hides the reservation buttons.
 * Anything but a client without a connection is still reported - an outage would otherwise hide every button unnoticed.
 */
export const transformReservationAvailabilityError = (response: FetchBaseQueryError) => {
    const originalStatus = getOriginalStatus(response);
    const report: ISilentErrorReport | null =
        response.status === "FETCH_ERROR"
            ? null
            : {
                  error: {
                      name: "ReservationAvailabilityError",
                      message: String(originalStatus ?? response.status),
                      groupingHash: "reservation_availability_failure"
                  },
                  context: "reservation availability failure",
                  metadata: {status: response.status, originalStatus}
              };

    return getSilentErrorResponse(response, report);
};
import {FetchBaseQueryError, FetchBaseQueryMeta} from "@reduxjs/toolkit/query";

import {getOriginalStatus} from "../../store/utils/get_original_status";
import {getSilentErrorResponse, ISilentErrorReport} from "../../store/utils/get_silent_error_response";
import {IReservationError, ReservationErrorKind, ReservationPhase} from "../types/IReservationError";
import {getApiErrorCode} from "./api_error_text";
import {normalizeReservationError} from "./normalize_reservation_error";

type ReservationErrorReporter = (error: IReservationError, originalStatus: number | undefined) => ISilentErrorReport;

const reportAuthError: ReservationErrorReporter = ({kind, phase, raw}, originalStatus) => ({
    error: {name: "ReservationAuthError", message: kind, groupingHash: `reservation_${phase}_${kind}`},
    context: `reservation ${phase}: ${kind}`,
    metadata: {raw, originalStatus}
});

// The kinds without a reporter are answers the flow expects
const RESERVATION_ERROR_REPORTERS: Partial<Record<ReservationErrorKind, ReservationErrorReporter>> = {
    // expected statuses, which would disappear from Bugsnag without a report
    unauthenticated: reportAuthError,
    not_verified: reportAuthError,
    forbidden: reportAuthError,
    csrf: reportAuthError,
    server: ({phase, raw}, originalStatus) => ({
        error: {name: "ReservationUpstreamError", message: String(originalStatus ?? raw.status), groupingHash: `reservation_${phase}_upstream`},
        context: `reservation ${phase} upstream failure`,
        metadata: {raw, originalStatus}
    }),
    // reported per code, so that a code the frontend does not map yet, a 409 without a code or a missing phone shows up
    rejected: ({phase, raw}) => {
        const apiErrorCode = getApiErrorCode(raw.data) ?? "no_code";

        return {
            error: {name: "ReservationRejectedError", message: apiErrorCode, groupingHash: `reservation_${phase}_rejected_${apiErrorCode}`},
            context: `reservation ${phase} rejected: ${apiErrorCode}`,
            metadata: {raw}
        };
    },
    // a status the flow does not expect, e.g. missing routes after a deployment or a success without its data
    unknown: ({phase, raw}) => ({
        error: {name: "ReservationUnexpectedError", message: String(raw.status), groupingHash: `reservation_${phase}_unexpected`},
        context: `reservation ${phase} unexpected response`,
        metadata: {raw}
    })
};

/**
 * `transformErrorResponse` of the initiate and confirm mutations: `data` becomes `IReservationError`.
 * Every status is silent - without it the RTK middleware turns a 5xx into the full-page error view, which unmounts the reservation modal.
 */
export const transformReservationError = (response: FetchBaseQueryError, phase: ReservationPhase, meta?: FetchBaseQueryMeta) => {
    const error = normalizeReservationError(response, phase, meta);
    const report = RESERVATION_ERROR_REPORTERS[error.kind]?.(error, getOriginalStatus(response)) ?? null;

    // the flag is set on the response object itself, so it has to be spread - a fresh object would lose it
    return {...getSilentErrorResponse(response, report), data: error};
};

/**
 * `transformErrorResponse` of the availability query: silent for the page, which only hides the reservation buttons.
 * Anything but a client without a connection is still reported - an outage would otherwise hide every button unnoticed.
 */
export const transformReservationAvailabilityError = (response: FetchBaseQueryError) => {
    const originalStatus = getOriginalStatus(response);
    const report: ISilentErrorReport | null =
        response.status === "FETCH_ERROR"
            ? null
            : {
                  error: {
                      name: "ReservationAvailabilityError",
                      message: String(originalStatus ?? response.status),
                      groupingHash: "reservation_availability_failure"
                  },
                  context: "reservation availability failure",
                  metadata: {status: response.status, originalStatus}
              };

    return getSilentErrorResponse(response, report);
};
